<template>
  <div class="empty-box">
    <div>
      <img :src="emptyImg" />
      <p>{{ text || $t('common.noData') }}</p>
    </div>
  </div>
</template>
<script>
import EmptyImg from "@/assets/images/img_empty@2x.png";
export default {
  name: "empty",
  props: {
    text: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      emptyImg: EmptyImg,
    };
  },
};
</script>
<style lang="less" scoped>
.empty-box {
  height: 180px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

  font-size: 14px;
  color: #b4b5bb;

  img{
    widows: 62px;
    height: 42px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/empty.vue